import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, FontAwesomeIcon } from "@nef/core"
import React, { useState } from "react"
import { Loader } from "@nef/icons"

import { FileExtensions } from "../../types/_enums"

const TableDownloadDropdown = ({ onDownloadClick, isFileDownloading, options = Object.keys(FileExtensions), ...props }: any) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  // handler for dropdown item select
  const handleItemSelect = (type: FileExtensions) => {
    onDownloadClick(type)
    setIsOpen(false)
  }
  return isFileDownloading ? (
    <Loader color="primary" intensity={600} size="md" />
  ) : (
    <div data-testid="tableDownloadDropdown">
    <Dropdown isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
      <DropdownToggle {...props} ghost={true}>
        <FontAwesomeIcon iconClassName="fa-arrow-alt-circle-down" />
      </DropdownToggle>
      <DropdownMenu maxContent={true}>
        <DropdownItem type="header">Export</DropdownItem>
        {options.map((option : keyof typeof FileExtensions ) => (
          <DropdownItem key={option} data-testid={`dropDownItem-${option}`} onClick={() => handleItemSelect(FileExtensions[option])}>{option}</DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
    </div>
  )
}

export default TableDownloadDropdown
